import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Marquee, AdBanner } from "@/components/AdBanner";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => setProducts(r.data)).catch(() => {});
    api.get("/banners").then((r) => setBanners(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="relative h-[78vh] min-h-[520px] w-full overflow-hidden bg-foreground">
        <img
          src="https://images.pexels.com/photos/33847264/pexels-photo-33847264.jpeg"
          alt="Bundles and Blends editorial hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <div className="relative h-full max-w-[1500px] mx-auto px-5 sm:px-8 flex flex-col justify-end pb-16">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-white/80 mb-4">FW26 Collection</div>
          <h1 className="font-heading font-black text-white text-5xl sm:text-7xl lg:text-8xl tracking-tighter uppercase leading-[0.85] max-w-3xl">
            Dress with<br />Intent<span className="text-accent">.</span>
          </h1>
          <div className="flex flex-wrap gap-4 mt-8">
            <Link to="/shop" data-testid="hero-shop-button" className="bg-white text-foreground px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white/90 transition-colors inline-flex items-center gap-2">
              Shop Collection <ArrowRight size={16} />
            </Link>
            <Link to="/shop?category=Outerwear" className="border border-white/40 text-white px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white/10 transition-colors">
              Outerwear
            </Link>
          </div>
        </div>
      </section>

      <Marquee text="FREE SHIPPING OVER £150" />

      {/* Featured */}
      <section className="max-w-[1500px] mx-auto px-5 sm:px-8 py-16">
        <div className="flex items-end justify-between mb-8 border-b border-border pb-4">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight uppercase">Featured</h2>
          <Link to="/shop" className="text-xs font-bold uppercase tracking-[0.18em] hover:text-accent transition-colors inline-flex items-center gap-1">View All <ArrowRight size={14} /></Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>

      {/* Ad banners */}
      {banners.map((b) => <AdBanner key={b.id} banner={b} />)}

      {/* Editorial split */}
      <section className="max-w-[1500px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1" alt="Editorial" className="w-full aspect-[4/5] object-cover" />
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-accent mb-4">The Philosophy</div>
          <h2 className="font-heading font-bold text-3xl sm:text-5xl tracking-tight uppercase leading-tight">Considered pieces, made to last.</h2>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">Each garment is selected for material, cut and longevity. We pair our own line with curated partner products so you can build a complete look in one place.</p>
          <Link to="/shop" className="inline-block mt-8 bg-foreground text-background px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-black/80 transition-colors">Explore the store</Link>
        </div>
      </section>
    </div>
  );
}
